import { render, staticRenderFns } from "./partnerLogin.vue?vue&type=template&id=015fafc0&scoped=true"
import script from "./partnerLogin.vue?vue&type=script&lang=js"
export * from "./partnerLogin.vue?vue&type=script&lang=js"
import style0 from "./partnerLogin.vue?vue&type=style&index=0&id=015fafc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015fafc0",
  null
  
)

export default component.exports